export const clientId = "81099eac-d94b-4500-a2e3-6f23f5204a9a";
export const clientSecret = 'HN48Q~4C2_ZWFnVoJ.D-Mnp4lXyEpLmVtsio7bzq';
export const reportId = "bb083eae-174c-4985-87f3-bb4ba6a3f43f";
export const workspaceId = "11f2e4c3-1a13-4285-bc40-09d59836052b";
export const datasetId = "99ca4e63-3c72-4dce-a1d9-e24c82430924";